import React, { Fragment, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../toast/SetToast";
import Toast from "../../toast/SetToast";
import { db } from "../../../../firebase";
import { useFirestore } from "../../../../hook/useFirestore";
import { setDoc, getDoc, updateDoc, doc, collection } from "firebase/firestore";
import { CPAPServiceForm } from "./CPAPServiceForm";

const CPAPServiceRegister = (props) => {
  const { addDocument } = useFirestore("cpapService");
  const inputRef = useRef({
    brand: "",
    model: "",
    withHumidifier: "",
    price: "",
    humidifierPrice: "",
    tubePrice: "",
    rentalPrice: "",
    IsActive: "Active",
  });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      brand: inputRef.current.brand,
      model: inputRef.current.model,
      withHumidifier: inputRef.current.withHumidifier,
      price: inputRef.current.price,
      humidifierPrice: inputRef.current.humidifierPrice,
      tubePrice: inputRef.current.tubePrice,
      rentalPrice: inputRef.current.rentalPrice,
      IsActive: inputRef.current.IsActive,
    };

    addDocument(formData)
      .then(() => {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        console.log(err);
        notifyError("บันทึกข้อมูลผิดพลาด ", err);
      });

    props.hide();
  };

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Register CPAP Service</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CPAPServiceForm onChange={handleChange} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default CPAPServiceRegister;
